function checkAndRequestLocation() {
  const savedCity = getCookie("city");
  const savedZip = getCookie("zipcode");
  const savedData = sessionStorage.getItem("locationData");
  const cityDisplay = document.getElementById('closest-city');
  const zipDisplay = document.getElementById('closest-zip');

  if(savedCity == null && savedZip == null) {
    // On initial page load, directly request geolocation without permission check
    requestGeolocationDirect();
  } else {
    cityDisplay.textContent = `${savedCity}`;
    zipDisplay.textContent = `${savedZip}`;
    if(savedData) {
      const parsedData = JSON.parse(savedData);
    }
  }
}

function updateRetryButtonVisibility() {
  const retryButton = document.getElementById('retry-location-btn');
  const savedCity = getCookie("city");
  const savedZip = getCookie("zipcode");
  
  console.log('Updating button visibility - City:', savedCity, 'Zip:', savedZip); // Debug
  
  if (retryButton) {
    if (savedCity && savedZip) {
      // Location data exists, hide button
      console.log('Hiding retry button - location data exists');
      retryButton.style.display = 'none';
    } else {
      // No location data, show button
      console.log('Showing retry button - no location data');
      retryButton.style.display = 'block';
    }
  } else {
    console.log('Retry button not found in DOM');
  }
}

function requestGeolocationDirect() {
  console.log('Requesting geolocation directly...'); // For debugging
  
  if (!navigator.geolocation) {
    console.error("Geolocation is not supported by this browser.");
    return;
  }

  navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
}

async function requestGeolocationWithPermissionCheck() {
  console.log('Requesting geolocation with permission check...'); // For debugging
  
  if (!navigator.geolocation) {
    console.error("Geolocation is not supported by this browser.");
    showGeolocationModal(); // Show modal if geolocation not supported
    return;
  }

  let permissionDenied = false;

  // Check if permissions API is available
  if (navigator.permissions) {
    try {
      const permission = await navigator.permissions.query({ name: 'geolocation' });
      console.log('Geolocation permission status:', permission.state);
      
      if (permission.state === 'denied') {
        console.log('Permission is denied, showing modal');
        showGeolocationModal();
        return;
      }
    } catch (error) {
      console.log('Permissions API not fully supported, proceeding with geolocation request');
    }
  }

  // If we get here, try the geolocation request
  navigator.geolocation.getCurrentPosition(
    successCallback, 
    function(error) {
      console.log('Geolocation failed on retry, error code:', error.code);
      if (error.code === error.PERMISSION_DENIED) {
        console.log('Permission denied on retry, showing modal');
        showGeolocationModal();
      } else {
        // For other errors, just log them
        errorCallback(error);
      }
    }
  );
}

function getBrowserType() {
  const userAgent = navigator.userAgent.toLowerCase();
  
  if (userAgent.includes('chrome') && !userAgent.includes('edg')) {
    return 'chrome';
  } else if (userAgent.includes('edg')) {
    return 'edge';
  } else if (userAgent.includes('firefox')) {
    return 'firefox';
  } else if (userAgent.includes('safari') && !userAgent.includes('chrome')) {
    return 'safari';
  } else {
    return 'chrome'; // Default to Chrome instructions for unknown browsers
  }
}

function getBrowserInstructions(browserType) {
  const instructions = {
    chrome: {
      name: 'Chrome',
      steps: [
        'Click the lock icon (🔒) or info icon (ℹ️) in the address bar',
        'Find "Location" and click on it',
        'Select "Allow"',
        'Refresh the page'
      ]
    },
    edge: {
      name: 'Microsoft Edge',
      steps: [
        'Click the lock icon (🔒) or info icon (ℹ️) in the address bar',
        'Find "Location" and click on it',
        'Select "Allow"',
        'Refresh the page'
      ]
    },
    firefox: {
      name: 'Firefox',
      steps: [
        'Click the (<img src="https://cdn.shopify.com/s/files/1/0706/5898/1923/files/blocked_location.png?v=1758739675" alt="info icon" style="width: 16px; height: 16px; vertical-align: middle;">) icon in the address bar',
        'Click to remove the "Blocked Temporarily" to clear this permission',
        'Refresh the page'
      ]
    },
    safari: {
      name: 'Safari',
      steps: [
        'Go to Safari menu → "Settings > select Websites tab"',
        'Find "Location", select this website and choose "Allow"',
        'Refresh the page'
      ]
    }
  };
  
  return instructions[browserType] || instructions.chrome;
}

function showGeolocationModal() {
  // Remove existing modal if present
  const existingModal = document.getElementById('geolocation-modal');
  if (existingModal) {
    existingModal.remove();
  }

  const browserType = getBrowserType();
  const browserInstructions = getBrowserInstructions(browserType);

  const modal = document.createElement('div');
  modal.id = 'geolocation-modal';
  modal.innerHTML = `
    <div style="
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 10000;
    ">
      <div style="
        background: white;
        border-radius: 8px;
        padding: 30px;
        max-width: 500px;
        max-height: 80vh;
        overflow-y: auto;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
        position: relative;
      ">
        <button id="close-modal" style="
          position: absolute;
          top: 15px;
          right: 15px;
          background: none;
          border: none;
          font-size: 24px;
          cursor: pointer;
          color: #666;
        ">&times;</button>
        
        <h4 style="margin-top: 0; color: #333;">Enable Location Services</h4>
        
        <p style="color: #666; margin-bottom: 20px;">
          Location access is currently blocked. To enable location services in ${browserInstructions.name}:
        </p>
        
        <ol style="color: #666; line-height: 1.8; margin-bottom: 30px; padding-left: 20px;">
          ${browserInstructions.steps.map(step => `<li style="margin-bottom: 8px;">${step}</li>`).join('')}
        </ol>
        
        <div style="text-align: center;">
          <button id="modal-close-btn" style="
            background: #000000;
            color: #f6C347;
            border: none;
            padding: 12px 24px;
            border-radius: 5px;
            cursor: pointer;
            font-size: 16px;
          ">Got it!</button>
        </div>
      </div>
    </div>
  `;

  document.body.appendChild(modal);

  // Add event listeners to close the modal
  document.getElementById('close-modal').addEventListener('click', closeModal);
  document.getElementById('modal-close-btn').addEventListener('click', closeModal);
  
  // Close modal when clicking outside the content
  modal.addEventListener('click', function(e) {
    if (e.target === modal) {
      closeModal();
    }
  });

  // Close modal on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeModal();
    }
  });
}

function closeModal() {
  const modal = document.getElementById('geolocation-modal');
  if (modal) {
    modal.remove();
  }
}

function successCallback(position) {
  console.log('Success callback triggered'); // Debug
  const latitude = position.coords.latitude;
  const longitude = position.coords.longitude;
  const cityDisplay = document.getElementById('closest-city');
  const zipDisplay = document.getElementById('closest-zip');
  const url = `https://api.storepoint.co/v1/16723da996a0c8/locations?lat=${latitude}&long=${longitude}&radius=100`;
  
  fetch(url)
  .then(response => {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  })
  .then(data => {
    console.log('Location data received successfully'); // Debug
    sessionStorage.setItem("locationData", JSON.stringify(data));
    const addr = data.results.locations[0].streetaddress;
    const match = addr.match(/,\s*([^,]+),\s*(\w{2})\s*(\d{5})/);
    
    if(match) {
      const city = match[1];
      const state = match[2];
      const zipCode = match[3];
      console.log('Setting cookies - City:', city, 'State:', state, 'Zip:', zipCode); // Debug
      
      setLocationCookie("city", city, 1);
      setLocationCookie("state", state, 1);
      setLocationCookie("zipcode", zipCode, 1);
      cityDisplay.textContent = `${city}`;
      zipDisplay.textContent = `${zipCode}`;
      
      console.log('About to update button visibility after success'); // Debug
      // Hide the retry button since we now have location data
      updateRetryButtonVisibility();
    }
  })
  .catch(error => {
    console.log("Error fetching data: ", error);
  });
}

function setLocationCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = `expires=${date.toUTCString()}`;
  
  // Check if we're on HTTPS or localhost
  const isSecure = location.protocol === 'https:' || location.hostname === 'localhost';
  const secureFlag = isSecure ? 'Secure; ' : '';
  
  const cookieString = `${name}=${value}; ${expires}; path=/; SameSite=Lax; ${secureFlag}`;
  document.cookie = cookieString;
  
  console.log('Setting cookie:', cookieString); // Debug
  console.log('Cookie after setting:', document.cookie); // Debug
}

function getCookie(name) {
  const nameEQ = `${name}=`;
  const cookies = document.cookie.split(';');
  for(let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();
    if(cookie.startsWith(nameEQ)) {
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
}

function errorCallback(error) {
  console.error("Error getting geolocation:", error);
  
  // Just log the errors, don't show modal
  switch(error.code) {
    case error.PERMISSION_DENIED:
      console.error("Location access denied by user");
      break;
    case error.POSITION_UNAVAILABLE:
      console.error("Location unavailable");
      break;
    case error.TIMEOUT:
      console.error("Location request timed out");
      break;
    default:
      console.error("Unknown location error");
      break;
  }
}